import { IdValue } from '../../shared/models/id-value.model';
import {
  AdditionalProdAssistants,
  citizenResidencyTypes,
  landValueTypes,
  LicensingAgencies,
  livingStatusTypes,
  LoanReferralsModel,
  maritalStatusTypes,
  tridSummariesOfTransactionSection,
} from './lookups';
import {
  accountType,
  assetTypes,
  bankingLiabilityAccountTypes,
  creditSourceTypes,
  creditTypes,
  liabilityTypes,
  reoPropertyStatuses,
} from './lookups/assets.lookups';
import { LoanProgram } from './lookups/loan-program.model';
import { PricingLookupsModel } from './lookups/pricing.lookups.model';
import { ZipcodeModel } from './lookups/zip-code.model';

export class Cmg1003LookupsModel {
  bankruptcyChapterTypes: IdValue<string, string>[];
  citizenResidencyTypes: IdValue<number, string>[];
  countries: IdValue<string, string>[];
  counties: IdValue<string>[];
  declarationPropertyTypes?: IdValue<string, string>[];
  declarationTitleHeldTypes?: IdValue<string, string>[];
  houseTypes: IdValue<string, string>[];
  infoProvidedTypes: IdValue<string, string>[];
  loanPurposeTypes: IdValue<string, string>[];

  /** From `/api/v1/lookups`. */
  loanStatusTypes: IdValue<string, string>[];

  /** From `/api/v1/lookups/loanstatusitems`. Similar to `loanStatusTypes`, but its `value` was translated by API to create a UI-friendly `name`. */
  loanStatusItems: IdValue<string, string>[];
  loanReferrals: LoanReferralsModel[];

  /** From `/api/v1/lookups/securityprofileroles`. */
  securityProfileRoles: IdValue<string, string>[];

  /** From `/api/v1/lookups/licensingagencies`. */
  licensingAgencies: LicensingAgencies[];

  maritalStatusTypes: IdValue<number, string>[];
  numberOfUnitTypes: IdValue<number, string>[];
  livingStatusTypes: IdValue<number, string>[];
  occupancyTypes: IdValue<number, string>[]; // adding this b/c API returns it. TODO: either get it removed from API or find its use in FE.
  serviceOrderVendorTypes: IdValue<number, string>[];
  serviceOrderVerificationTypes: IdValue<number, string>[];

  propertyTypes: IdValue<string, string>[]; // Not yet in API.
  retailCompPlans: IdValue<string, string>[];
  retailLeadTypes: IdValue<string, string>[];
  states: IdValue<string, string>[]; // TODO: Remove this after updating borrower-address & borrower-details to uses states from common.lookup.ts.
  waiveEscrowTypes: IdValue<number, string>[];
  loanPrograms: LoanProgram[];
  jrloNames: IdValue<string, string>[];
  additionalProdAssistants: AdditionalProdAssistants;
  relocationRefTypes: IdValue<string, string>[];

  //transaction
  tridSummariesOfTransactionSection: IdValue[];
  landValueTypes: IdValue[];
  assetTypes: IdValue[];
  creditSourceTypes: IdValue<number, string, string>[];
  creditTypes: IdValue<number, string, string>[];
  liabilityTypes: IdValue<number, string, string>[];
  bankingLiabilityAccountTypes: IdValue<number, string, string>[];
  accountType: IdValue<number, string, string>[];
  propertyStatuses: IdValue<number, string, string>[];

  // Pricing Lookups
  pricing: PricingLookupsModel;

  // Zip Code Lookup Cache
  zipCodeModels: Record<string, ZipcodeModel> = {};

  // States where the Unmarried Borrower Addendum is required. From `/api/v1/lookups`.
  unmarriedBorrowerAddendumStates: string[];

  static loadLookups() {
    const lookupsModel = new Cmg1003LookupsModel();
    lookupsModel.maritalStatusTypes = maritalStatusTypes;
    lookupsModel.tridSummariesOfTransactionSection = tridSummariesOfTransactionSection;
    lookupsModel.landValueTypes = landValueTypes;
    lookupsModel.citizenResidencyTypes = citizenResidencyTypes;
    lookupsModel.assetTypes = assetTypes;
    lookupsModel.creditSourceTypes = creditSourceTypes;
    lookupsModel.creditTypes = creditTypes;
    lookupsModel.liabilityTypes = liabilityTypes;
    lookupsModel.bankingLiabilityAccountTypes = bankingLiabilityAccountTypes;
    lookupsModel.accountType = accountType;
    lookupsModel.propertyStatuses = reoPropertyStatuses;
    lookupsModel.livingStatusTypes = livingStatusTypes;
    return lookupsModel;
  }
}
